<!--
 * @Author: Gaho
 * @Date: 2024-04-19 10:38:21
 * @LastEditors: Merlin
 * @LastEditTime: 2024-10-30 17:25:26
 * @Description: 这个组件用于显示 crash & circle 的某局游戏的所参与者的结果 
-->
<template>
    <ClientOnly>
        <ModalTitle
            v-model="showModal"
            @update:model-value="onUpdateModelVisible"
            class="round-details"
            scopeid="RoundDetails-g3j69o9f2s4"
        >
            <template v-slot:header>
                <div class="flex justify-between flex-1">
                    <span>{{ $t('roundDetail') }}</span>
                </div>
            </template>
            <!-- ↑ 顶部 header -->
            <!-- ↓ 这是弹出窗口的核心内容 -->
            <div class="max-h-[85vh] overflow-auto !overflow-x-hidden text-white"
                :ref="el => el && (contentRef = el)"
            >
                <CasinoHistoryModalRoundDetailsRoundBody
                    :history="history"
                />
                <!-- ↑ 游戏信息，↓ 一个表格 -->
                <CasinoHistoryModalRoundDetailsRoundLists 
                    :history="history" 
                    @onUpdateModelValue="checkUserInfo" 
                />
            </div>
        </ModalTitle>
    </ClientOnly>
</template>

<script lang="ts" setup>
import { useGameSocket } from '@/socket/game';

const contentRef = ref({}); // 之前默认值为 null，但控制台总报错 
const history = ref({});
const showModal = ref(false);
const { EMIT_CIRCLE_ROUNDINFO, EMIT_CRASH_ROUNDINFO } = useGameSocket();
const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true,
    },
    roundNum: {
        type: Number,
        required: true,
    },
    gameName: {
        type: String,
        required: true,
    },
});

const emits = defineEmits(['handleOpenModel', 'update:modelValue']);

const onUpdateModelVisible = (value: boolean) => {
    showModal.value = value;
    emits('update:modelValue', value); 
};

// ↓ 弹出特定用户的窗口 
const checkUserInfo = (row)=>{
    onUpdateModelVisible(false);
    emits('handleOpenModel', row); 
}

// ↓ 监听组件自身（窗口）的开关事件 
watch(() => props.modelValue, (newVal) => {
    showModal.value = newVal;
    if (!newVal) {
        history.value = {}; // 清空，防止下次开窗时呈现旧数据 
        return; // 到此为止
    }
    const params = { roundNum: props.roundNum };
    if (props.gameName === 'circle'){
        EMIT_CIRCLE_ROUNDINFO(params, setRoundRecord);
    }else if (props.gameName === 'crash'){
        EMIT_CRASH_ROUNDINFO(params, setRoundRecord);
    }
});

// ↓ 查询游戏记录，并修正数据
function setRoundRecord(oHistoryRound) {
    const {gameName} = props;
    console.log(`${gameName} 游戏历史信息如下\n`, deepCopy(oHistoryRound)); 
    if (!oHistoryRound) return;
    // ↓ 为 crash 游戏修改变量名，使其与 circle 键名一致，以便于组件准确呈现这些数据 
    if (gameName == 'crash' && oHistoryRound.bets){
        oHistoryRound.bets.forEach(cur => {
            cur.user ||= cur.User;
            cur.multi ||= Number(cur.stopped || 0).toFixed(2);
        });
        oHistoryRound.random_seed ||= oHistoryRound.randomSeed;
    }
    history.value = oHistoryRound;
}

</script>
<style lang="scss">
.round-details[scopeid="RoundDetails-g3j69o9f2s4"] .modalHeader{
    max-width: 96vw;
}
</style>
